import type * as THREE from 'three';
import type { Entity } from '../../entities';

export interface Collidable {
  readonly collisionRadius: number;
  readonly collisionStatic: boolean;
  readonly collisionRestitution: number;
  getCollisionCenter(out: THREE.Vector3): THREE.Vector3;
}

export function isCollidable(entity: Entity): entity is Entity & Collidable {
  const candidate = entity as Entity & Partial<Collidable>;
  return (
    typeof candidate.collisionRadius === 'number' &&
    typeof candidate.getCollisionCenter === 'function'
  );
}
